import { useEffect } from 'react'
const useWindowPositionTop = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
};
export default useWindowPositionTop;